import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';

import { ContactDialogComponent } from './contact-dialog.component';

@NgModule({
	declarations: [ContactDialogComponent],
	imports: [RouterModule, BrowserModule, DialogModule, InputTextModule, ReactiveFormsModule, FormsModule],
	exports: [ContactDialogComponent],
})
export class ContactDialogModule {}
